import { useIntl } from 'react-intl';
import { Fields } from 'redux-form';

import { NameComponent } from './NameComponent';
import styles from './NameField.module.css';

const NameField = (props) => {
    const { label, ...restProps } = props;
    const intl = useIntl();

    const names = ['title', 'firstName', 'lastName'];

    const placeholder = {
        title: intl.formatMessage({
            id: '_.name_field.title',
            defaultMessage: 'Title'
        }),
        first_name: intl.formatMessage({
            id: '_.name_field.first_name',
            defaultMessage: 'First name'
        }),
        last_name: intl.formatMessage({
            id: '_.name_field.last_name',
            defaultMessage: 'Last name'
        })
    };

    return (
        <div className={styles.NameField}>
            <label className={styles.label}>{label}</label>
            <Fields
                placeholder={placeholder}
                names={names}
                component={NameComponent}
                {...restProps}
            />
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default NameField;
